import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock'
import scrollbarWidth from './scrollbar-width'

const page = document.querySelector('body')
const containers = document.querySelectorAll('[data-padding-container]')
const header = document.querySelector('[data-header]')
const menuButton = document.querySelector('[data-menu-button]')
const menuPage = document.querySelector('[data-menu]')
const menuLinks = document.querySelectorAll('[data-menu] a')
const closeMenu = document.querySelector('[data-close-menu]')

const menuIsActive = () => page.classList.contains('menu-is-active')
const scrollbar = scrollbarWidth()

const toggleScrollbar = () => {
  if (menuIsActive()) {
    disableBodyScroll(menuPage)
  } else {
    enableBodyScroll(menuPage)
  }
  page.style.paddingRight = menuIsActive() ? `${scrollbar}px` : ''
  containers.forEach(
    video => (video.style.paddingRight = menuIsActive() ? `${scrollbar}px` : '')
  )
  header.style.paddingRight = menuIsActive() ? `${scrollbar}px` : ''
}

const toggleMenu = () => {
  page.classList.toggle('menu-is-active')
  menuButton.classList.toggle('header__menu--active')
  menuPage.classList.toggle('menu--show')
  menuButton.style.visibility = 'visible'
  // if (menuIsActive()) {
  //   header.classList.remove('header--visible')
  //   header.classList.add('header--hidden')
  // } else {
  //   header.classList.remove('header--hidden')
  //   header.classList.add('header--visible')
  // }
  toggleScrollbar()
  menuPage.style.backgroundImage = menuPage.dataset.lazyBg
}

if (menuButton) {
  menuButton.addEventListener('click', () => {
    toggleMenu()
  })
}

menuLinks.forEach(link => {
  link.addEventListener('click', () => {
    toggleMenu()
  })
})

if (closeMenu) {
  closeMenu.addEventListener('click', () => {
    if (menuIsActive()) {
      toggleMenu()
    }
  })
}
